<div class="access">
  <p class="access__lead">
    {{ (curated ? 'tutor.moodleDozentAccess.leadCurated' : 'tutor.moodleDozentAccess.leadAll') | translate }}
  </p>

  <p *ngIf="loading" class="access__muted">{{ 'tutor.moodleDozentAccess.loading' | translate }}</p>

  <p *ngIf="error" class="access__error">{{ error }}</p>

  <ng-container *ngIf="access as a">
    <p *ngIf="!a.pii_enabled && a.candidates.length" class="access__note">
      {{ 'tutor.moodleDozentAccess.noPii' | translate }}
    </p>

    <p *ngIf="a.site_admins_note && a.candidates.length" class="access__note">
      {{ 'tutor.moodleDozentAccess.siteAdmins' | translate }}
    </p>

    <p *ngIf="!a.candidates.length && !loading" class="access__muted">
      {{ 'tutor.moodleDozentAccess.empty' | translate }}
    </p>

    <ng-container *ngIf="a.candidates.length">
      <div class="access__toolbar">
        <input
          nbInput
          fieldSize="small"
          type="search"
          [(ngModel)]="search"
          [placeholder]="'tutor.moodleDozentAccess.search' | translate"
        />
        <span *ngIf="curated" class="access__count">
          {{ 'tutor.moodleDozentAccess.selectedCount' | translate:{ n: selectedCount } }}
        </span>
        <span *ngIf="!curated" class="access__badge">
          {{ 'tutor.moodleDozentAccess.previewBadge' | translate }}
        </span>
        <span class="access__actions" *ngIf="curated">
          <button type="button" class="link-btn" (click)="selectAllInScope()">
            {{ 'tutor.moodleDozentAccess.selectInScope' | translate:{ n: inScopeCount } }}
          </button>
          <button type="button" class="link-btn" (click)="clearSelection()">
            {{ 'tutor.moodleDozentAccess.clear' | translate }}
          </button>
        </span>
      </div>

      <ul class="access__list" [class.is-preview]="!curated">
        <li *ngFor="let c of candidates" [class.is-out]="!c.in_scope">
          <label class="person">
            <input
              type="checkbox"
              [checked]="hasAccess(c)"
              [disabled]="!curated || saving"
              (change)="toggle(c, $any($event.target).checked)"
            />
            <span class="person__name">{{ displayName(c) }}</span>
            <span class="person__meta">
              <span class="person__roles">{{ c.roles.join(', ') }}</span>
              <span class="person__courses">{{ courseSummary(c) }}</span>
            </span>
          </label>
        </li>
      </ul>

      <div class="access__footer" *ngIf="curated">
        <button
          nbButton
          size="small"
          status="primary"
          [disabled]="saving"
          (click)="save()"
        >
          {{ (saving ? 'tutor.moodleDozentAccess.saving' : 'tutor.moodleDozentAccess.save') | translate }}
        </button>
      </div>
    </ng-container>
  </ng-container>
</div>
